export const filterActivities = (activities?: any[]) => {
  if (!Array.isArray(activities)) return [];
  // exclude 'Affordable Waitlist' from manual selection to prevent breaking the workflow
  return activities.filter((activity) => {
    if (activity?.value === 'default') return true;

    return activity?.text !== 'Affordable Waitlist';
  });
};

export default {
  filterActivities,
};
